import { useState } from 'react';
import axios from 'axios';
import { API_STATUS } from '../utils/constants';
import { getApiHeaders } from '../utils/header-util';
import { toastWarn } from '../utils/toasts';

export function useSave() {
   const [saveResponseData, setSaveResponseData] = useState(null);
   const [saveStatus, setSaveStatus] = useState(API_STATUS.IN_PROGRESS);

   const saveData = async (payload, url, method = 'post') => {
      try {
         setSaveStatus(API_STATUS.IN_PROGRESS);
         const response = await axios[method](url, payload, {
            headers: getApiHeaders(),
         });

         if (response.status !== 200) {
            toastWarn(response.data.message);
            setSaveResponseData([]);
            setSaveStatus(API_STATUS.FAILED);
            return null;
         } else {
            setSaveResponseData(response?.data);
            setSaveStatus(API_STATUS.SUCCESS);
            return response?.data;
         }
      } catch (error) {
         console.warn('Error in saving records', error);
         setSaveResponseData([]);
         setSaveStatus(API_STATUS.FAILED);
         toastWarn(error.message);
         return null;
      }
   };

   return { saveResponseData, saveStatus, saveData };
}
